import React from 'react';
import SIcon from './SIcon';
import { faCogs } from '@fortawesome/pro-regular-svg-icons';

const Icon = props => <SIcon {...props} icon={faCogs} fa />;

export default Icon;
